export default {"src":"/_next/static/media/applications.95e7bf0e.svg","height":770,"width":953,"blurWidth":0,"blurHeight":0};